import { render, staticRenderFns } from "./SetTestTable.vue?vue&type=template&id=172e373a&scoped=true&"
import script from "./SetTestTable.vue?vue&type=script&lang=js&"
export * from "./SetTestTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172e373a",
  null
  
)

export default component.exports